import { format } from "date-fns";

export function htmlDate(date: Date) {
  return format(date, "yyyy-MM-dd'T'HH:mm");
}
